/* eslint-disable react/prop-types */
const REACTIONS = [
	{ emoji: "\ud83d\udc4d", name: "Like", value: "like" },
	{ emoji: "\u2764\ufe0f", name: "Love", value: "love" },
	{ emoji: "\ud83c\udf89", name: "Celebrate", value: "celebrate" },
	{ emoji: "\ud83d\ude02", name: "Haha", value: "haha" },
	{ emoji: "\ud83d\ude2e", name: "Wow", value: "wow" }
];

interface ReactionPickerProps {
	onReact: (reaction: string) => void;
	onClose: () => void;
}

const ReactionPicker = ({ onReact, onClose }: ReactionPickerProps) => {
	return (
		<div className="absolute bottom-full left-0 mb-2 z-10">
			<div className="flex items-center gap-1 bg-white rounded-full shadow-lg border border-border px-2 py-1.5">
				{REACTIONS.map((r) => (
					<button
						key={r.value}
						type="button"
						aria-label={r.name}
						className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-subtle transition-colors text-lg"
						onClick={(e) => {
							e.stopPropagation();
							onReact(r.value);
							onClose();
						}}
					>
						{r.emoji}
					</button>
				))}
			</div>
		</div>
	);
};

export { REACTIONS };
export default ReactionPicker;
